import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from 'react-spreadsheet-grid';
import { fetchReportCAPRequest } from '../redux/actions';
import { Typography } from '@mui/material';
import GridTitle from './GridTitle';
import GridTypography from './GridTypography';
import Loader from './Loader';

function ReportCAP(props) {
    const { engagementCode, branchSubCode } = props;
    const dispatch = useDispatch();

    const [columns, setColumns] = useState([])
    const [rows, setRows] = useState([]);

    const { loading, data: reportCAPDataSet, error } = useSelector((state) => state.reportCAP);

    useEffect(() => {
        if (engagementCode && branchSubCode) {
            dispatch(fetchReportCAPRequest(engagementCode, branchSubCode));
        }
    }, [branchSubCode, dispatch, engagementCode]);

    useEffect(() => {
        if (reportCAPDataSet) {
            setRows(reportCAPDataSet);
        }
    }, [reportCAPDataSet]);

    const initColumns = () => {
        return [
            {
                title: () => {
                    return (
                        <GridTitle title="Aggregate Name for CAP" tooltip="Aggregate Name for CAP" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.aggregate} tooltip={row.aggregate} />
                    );
                },
                id: 'aggregate',
            }, {
                title: () => {
                    return (
                        <GridTitle title="FS Lines - same as in TB" tooltip="FS Lines - same as in TB" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.fsline} tooltip={row.fsline} />
                    );
                },
                id: 'fsline',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Sum of Final" tooltip="Sum of Final" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.final} tooltip={row.final} />
                    );
                },
                id: 'final',
            }, {
                title: () => {
                    return (
                        <GridTitle title="Sum of Previous Year" tooltip="Sum of Previous Year" />
                    )
                },
                value: (row, { focus }) => {
                    return (
                        <GridTypography title={row.pfy} tooltip={row.preliminary} />
                    );
                },
                id: 'pfy',
            }
        ]
    };

    useEffect(() => {
        if (rows && rows.length > 0) {
            setColumns(initColumns());
        }
    }, [rows])

    return (
        <>
            {loading && <Loader />}
            {error && <Typography color="error">Error: {error}</Typography>}
            {columns && columns.length > 0 &&
                <Grid
                    columns={columns}
                    rows={rows}
                    getRowKey={row => row.tbId}
                    focusOnSingleClick={true}
                    isScrollable
                />
            }
        </>
    )
}

export default ReportCAP;